import { render, staticRenderFns } from "./PCOverviewV2.vue?vue&type=template&id=4ee213a6&scoped=true"
import script from "./PCOverviewV2.vue?vue&type=script&setup=true&lang=js"
export * from "./PCOverviewV2.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PCOverviewV2.vue?vue&type=style&index=0&id=4ee213a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee213a6",
  null
  
)

export default component.exports